import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14010978"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("b", null, "寵物芭比娃娃系列 (1隻寵物)")
], -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 寵物資料 ")
const _hoisted_9 = {
  key: 0,
  class: "ion-padding-horizontal"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 您的寵物種類 ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("按此選擇寵物種類*")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-padding-horizontal" }, " 上傳您的寵物照片 (全身、正面、側面、背面等) **建議照片愈多愈好 ", -1))
const _hoisted_13 = ["src", "onClick"]
const _hoisted_14 = { class: "ion-padding-horizontal" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 特徵描述 ", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  action: "/charge",
  method: "post",
  id: "payment-form"
}
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = { ref: "cardElement" }
const _hoisted_21 = {
  ref: "cardErrors",
  role: "alert"
}
const _hoisted_22 = {
  ref: "inviInput",
  type: "tel",
  style: {"border":"0px","color":"transparent","width":"0px","height":"0px","background":"transparent"}
}
const _hoisted_23 = { class: "ion-text-center ion-margin-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        title: $setup.t('checkout'),
        parentPath: "/home"
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => ($setup.submitOrder($setup.order)), ["prevent"]))
              }, [
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list_header, { color: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('CheckoutPage.yourOrder')), 1)
                      ]),
                      _: 1
                    }),
                    ($setup.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_component_ion_spinner)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          ($setup.isOrderingBabeProduct())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cartItems, (item, i) => {
                                  return (_openBlock(), _createBlock(_component_ion_item, { key: i }, {
                                    default: _withCtx(() => [
                                      (item.selectedSet.previewImage)
                                        ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                            key: 0,
                                            slot: "start",
                                            onClick: ($event: any) => ($setup.openImageModal(item.selectedSet.previewImage))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: item.selectedSet.previewImage
                                              }, null, 8, _hoisted_4)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _hoisted_5,
                                          _createElementVNode("p", null, _toDisplayString($setup.t('CartPage.lineTotal')) + "HK$" + _toDisplayString(Number(item.unitPrice * item.quantity).toLocaleString()), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cartItems, (item, i) => {
                                  return (_openBlock(), _createBlock(_component_ion_item, { key: i }, {
                                    default: _withCtx(() => [
                                      (item.designDataURL)
                                        ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                            key: 0,
                                            slot: "start",
                                            onClick: ($event: any) => ($setup.openImageModal(item.designDataURL))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: item.designDataURL
                                              }, null, 8, _hoisted_7)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, [
                                            _createElementVNode("b", null, "手作寵物LED保鮮花瓶 (" + _toDisplayString(item.bottleId) + _toDisplayString(item.numOfPets ? `${item.numOfPets}隻寵物` : '') + ")", 1)
                                          ]),
                                          _createElementVNode("p", null, _toDisplayString($setup.t('CartPage.lineTotal')) + "HK$" + _toDisplayString(Number(item.unitPrice * item.quantity).toLocaleString()), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ])),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString($setup.t('CheckoutPage.estimatedDeliveryDate')) + _toDisplayString($setup.isOrderingBabeProduct() ? $setup.estimatedDeliveryDateBabe : $setup.estimatedDeliveryDate), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          "size-xs": "12",
                          "size-md": "6",
                          "size-lg": "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  class: "ion-text-wrap",
                                  position: "fixed",
                                  style: {"flex":"0 0 50px","min-width":"50px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('CheckoutPage.discountCode')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: $setup.order.discountCode,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.order.discountCode) = $event)),
                                  disabled: $setup.order.appliedDiscountCode != ''
                                }, null, 8, ["modelValue", "disabled"]),
                                _withDirectives(_createVNode(_component_ion_spinner, { name: "crescent" }, null, 512), [
                                  [_vShow, $setup.checkingDiscountCode]
                                ]),
                                _withDirectives(_createVNode(_component_ion_button, {
                                  size: "default",
                                  slot: "end",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.applyDiscountCode())),
                                  disabled: $setup.order.discountCode == ''
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: $setup.arrowForward
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]), [
                                  [_vShow, !$setup.checkingDiscountCode && $setup.order.appliedDiscountCode == '']
                                ]),
                                _withDirectives(_createVNode(_component_ion_button, {
                                  size: "default",
                                  fill: "clear",
                                  slot: "end",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.resetDiscountCode()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: $setup.closeOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, $setup.order.appliedDiscountCode]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString($setup.t('CheckoutPage.subTotal')) + "HK$" + _toDisplayString($setup.getCartTotal().toLocaleString()), 1),
                            _withDirectives(_createElementVNode("p", null, _toDisplayString($setup.t('CheckoutPage.discountTotal')) + "- HK$" + _toDisplayString($setup.getDiscountTotal().toFixed(1).toLocaleString()), 513), [
                              [_vShow, $setup.getDiscountTotal() > 0]
                            ]),
                            _createElementVNode("h3", null, [
                              _createElementVNode("b", null, _toDisplayString($setup.t('CheckoutPage.orderTotal')) + "HK$" + _toDisplayString($setup.getOrderTotal().toFixed(1).toLocaleString()), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list_header, { color: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    ($setup.isOrderingBabeProduct())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_ion_item, {
                            fill: "outline",
                            onClick: $setup.openBreedSelectModal,
                            button: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                type: "text",
                                modelValue: $setup.order.petTypeName,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.order.petTypeName) = $event)),
                                clearInput: true
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_12,
                    _createVNode(_component_ion_grid, { class: "ion-text-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.photos, (photo) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                "size-xs": "4",
                                "size-md": "3",
                                "size-xl": "2",
                                key: photo
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card, { class: "photo-card ion-align-items-center ion-justify-content-center ion-text-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_buttons, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_button, {
                                            slot: "icon-only",
                                            onClick: ($event: any) => ($setup.deletePhoto(photo))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("img", {
                                        src: photo.base64Data,
                                        onClick: ($event: any) => ($setup.openImageModal(photo.base64Data))
                                      }, null, 8, _hoisted_13)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            _createVNode(_component_ion_col, {
                              size: "4",
                              "size-lg": "3",
                              "size-xl": "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, { class: "photo-card ion-align-items-center ion-justify-content-center ion-text-center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_fab_button, {
                                      size: "small",
                                      class: "take-photo-fab-btn",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.takePhoto()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.camera }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_ion_item, { fill: "outline" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_textarea, {
                            "auto-grow": true,
                            modelValue: $setup.order.petFeatureRemark,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.order.petFeatureRemark) = $event)),
                            placeholder: "例子：左眼有黑眼圈、鼻子有白點⋯"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list_header, { color: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('CheckoutPage.deliveryInfo')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment, {
                      modelValue: $setup.order.deliveryMethod,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.order.deliveryMethod) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_segment_button, { value: "送貨上門" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('CheckoutPage.delivery')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_ion_segment_button, { value: "自取" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('CheckoutPage.pickup')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, $setup.pickupPoints.length > 0]
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    ($setup.order.deliveryMethod == '送貨上門')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "stacked" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('deliveryAddress')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_textarea, {
                                placeholder: $setup.t('CheckoutPage.enterDeliveryAddress'),
                                modelValue: $setup.order.deliveryAddress,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.order.deliveryAddress) = $event)),
                                required: ""
                              }, null, 8, ["placeholder", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : ($setup.order.deliveryMethod == '自取')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('CheckoutPage.pickupPoint')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select, {
                                  placeholder: $setup.t('CheckoutPage.selectPickupPoint'),
                                  interface: "action-sheet",
                                  modelValue: $setup.order.pickupPoint,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.order.pickupPoint) = $event)),
                                  onIonChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.onPickupPointChanged($event))),
                                  "aria-required": "required"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pickupPoints, (point) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: point.id,
                                        value: point.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(point.name ? `${point.name} | ` : "") + _toDisplayString(point.address), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["placeholder", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('customerName')) + "*", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          placeholder: $setup.t('CheckoutPage.enterCustomerName'),
                          modelValue: $setup.order.customerName,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.order.customerName) = $event)),
                          required: ""
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('contactPhone')) + "*", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          placeholder: $setup.t('CheckoutPage.enterContactPhone'),
                          inputmode: "numeric",
                          modelValue: $setup.order.contactPhone,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.order.contactPhone) = $event)),
                          required: ""
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('customerEmail')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          placeholder: $setup.t('CheckoutPage.enterCustomerEmail'),
                          type: "email",
                          modelValue: $setup.order.customerEmail,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.order.customerEmail) = $event)),
                          required: ""
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_radio_group, {
                      modelValue: $setup.order.paymentMethod,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.order.paymentMethod) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list_header, { color: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentMethod')), 1)
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paymentMethods, (method) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: method.value
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_radio, {
                                slot: "start",
                                value: method.value,
                                required: ""
                              }, null, 8, ["value"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t(method.key)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_icon, {
                                icon: method.icon,
                                slot: "end"
                              }, null, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("form", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, null, 512),
                    _createElementVNode("div", _hoisted_21, null, 512)
                  ])
                ], 512), [
                  [_vShow, $setup.order.paymentMethod == 'card']
                ]),
                _createElementVNode("input", _hoisted_22, null, 512),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_ion_button, {
                    type: "submit",
                    expand: "block",
                    disabled: $setup.order.submittingOrder
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.confirmPayment')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_note, null, {
                    default: _withCtx(() => [
                      _createElementVNode("small", null, [
                        _createTextVNode(_toDisplayString($setup.t('CheckoutPage.agreeTC')) + " ", 1),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => ($setup.openTCModal()), ["prevent"]))
                        }, _toDisplayString($setup.t('CheckoutPage.orderTC')), 1)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}